import { render } from "./DataCollectionUpload.vue?vue&type=template&id=6746d43f&scoped=true"
import script from "./DataCollectionUpload.vue?vue&type=script&lang=js"
export * from "./DataCollectionUpload.vue?vue&type=script&lang=js"

import "./DataCollectionUpload.vue?vue&type=style&index=0&id=6746d43f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6746d43f"]])

export default __exports__